import { render, staticRenderFns } from "./DataBuildForRiceFarm.vue?vue&type=template&id=71097fd8&scoped=true&"
import script from "./DataBuildForRiceFarm.vue?vue&type=script&lang=js&"
export * from "./DataBuildForRiceFarm.vue?vue&type=script&lang=js&"
import style0 from "./DataBuildForRiceFarm.vue?vue&type=style&index=0&id=71097fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71097fd8",
  null
  
)

export default component.exports